export default __webpack_public_path__ + "static/media/Caju Bags.f142f269.jpg";